import React from 'react'

import Block from './Block'

import './styles.scss'
import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'
const bc = 'reports-section'

const Section = ({ question, answers, reviewers }) => (
  <div className={bc}>
    <span className={`${bc}__question`} dangerouslySetInnerHTML={{ __html: question }} />
    <div className={`${bc}__content`}>
      <Block reviewerType="Self" responses={answers['Self']} color="rgba(241, 195, 49, 1)" />
      {!!reviewers[TYPE_OF_REVIEWERS.SUPERIOR] && (
        <Block reviewerType="Supervisors" responses={answers['Supervisors']} color="rgba(45, 216, 120, 1)" />
      )}
      {!!reviewers[TYPE_OF_REVIEWERS.PEER] && (
        <Block reviewerType="Peers" responses={answers['Peers']} color="rgba(60, 120, 216, 1)" />
      )}
      {!!reviewers[TYPE_OF_REVIEWERS.EMPLOYEE] && (
        <Block reviewerType="Direct Reports" responses={answers['Direct']} color="rgba(102, 78, 167, 1)" />
      )}
    </div>
  </div>
)

export default Section
